import type {ReactNode} from 'react';

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import {ItemGroup} from '@/components/ui/item';
import {Typography} from '@/components/ui/typography';

import {useAutoCollapse} from '../hooks/useAutoCollapse';
import EvacuationCountBadge from './EvacuationCountBadge';

type EvacuationGroupProps = {
  title: string;
  confirmedCount: number;
  totalCount: number;
  forceOpen?: boolean;
  children: ReactNode;
};

const EvacuationGroup = ({
  title,
  confirmedCount,
  totalCount,
  forceOpen,
  children,
}: EvacuationGroupProps) => {
  const {isOpen, onOpenChange} = useAutoCollapse(
    confirmedCount,
    totalCount,
    forceOpen
  );

  return (
    <Collapsible open={isOpen} onOpenChange={onOpenChange}>
      <CollapsibleTrigger>
        <Typography variant="h6" asChild>
          <span className="grow">{title}</span>
        </Typography>
        <EvacuationCountBadge
          confirmedCount={confirmedCount}
          totalCount={totalCount}
        />
      </CollapsibleTrigger>
      <CollapsibleContent asChild>
        <ItemGroup>{children}</ItemGroup>
      </CollapsibleContent>
    </Collapsible>
  );
};

export default EvacuationGroup;
